import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

const FIELDS = [
    ['sponsorName', 'Sponsor name', 'text', 'Check Financial'],
    ['sponsorImageUrl', 'Banner image URL (728×90)', 'url', 'https://…'],
    ['sponsorUrl', 'Sponsor link', 'url', 'https://…'],
    ['sponsorStartsAt', 'Runs from', 'datetime-local'],
    ['sponsorEndsAt', 'Runs until', 'datetime-local'],
];

// The living story's one ad slot. Saving it does not count as an update to the story.
// Off while the alert offers a story research sponsorship: one sponsor per page, and the API refuses it.
const StorySponsorFields = ({ draft, onChange, researchOn }) => (
    <fieldset className={styles.faqOffer} disabled={researchOn}>
        <legend className={styles.kicker}>Sponsor slot</legend>
        <p className={styles.hint}>
            {researchOn
                ? 'Not available: this alert offers a story research sponsorship, and the page carries one sponsor. Turn it off in Edit first.'
                : 'One labelled ad above the headline. Links in the story to the sponsor\u2019s site are marked sponsored automatically. Leave the dates empty to run it from now with no end.'}
        </p>
        {FIELDS.map(([name, label, type, placeholder]) => (
            <div key={name}>
                <label className={styles.label} htmlFor={`story-${name}`}>
                    {label}
                </label>
                <input
                    id={`story-${name}`}
                    className={styles.input}
                    type={type}
                    value={draft[name]}
                    maxLength={type === 'datetime-local' ? undefined : 1000}
                    placeholder={placeholder}
                    onChange={(e) => onChange(name, e.target.value)}
                />
            </div>
        ))}
    </fieldset>
);

export default StorySponsorFields;
